import React from "react";
import {
    MessageRibbonOverlayContainer,
    CustomMessageRibbonOverlay,
    StripesLeft,
    StripesRight
} from "./MessageRibbonOverlay.styles";
import { Typography } from "@mui/material";

export interface CustomMessageRibbonOverlayProps {
    message?: string;
    variant?: "warning" | "subtle";
}

export const MessageRibbonOverlay = ({
    message = "",
    variant = "warning"
}: CustomMessageRibbonOverlayProps) => {
    const isSubtle = variant === "subtle";

    return (
        <MessageRibbonOverlayContainer sx={isSubtle ? { backgroundColor: "rgba(59,130,246,0.25)" } : undefined}>
            {!isSubtle && <StripesLeft />}
            <CustomMessageRibbonOverlay
                sx={(theme) => ({
                    fontSize:
                        message && message.length < 20
                        ? theme.fontSizes["2xl"]
                        : theme.fontSizes["xl"],
                    ...(isSubtle && {
                        color: "rgba(147,197,253,0.95)",
                        fontWeight: theme.fontWeights.semibold,
                        maxWidth: "90%",
                        textAlign: "center",
                        fontSize: theme.fontSizes.sm,
                        lineHeight: 1.3,
                        whiteSpace: "pre-line",
                    }),
                })}
            >
               {message}
            </CustomMessageRibbonOverlay>
            {!isSubtle && <StripesRight />}
        </MessageRibbonOverlayContainer>
    );
};

export interface MessageRibbonOverlayProps extends React.ComponentProps<typeof MessageRibbonOverlay> {
    as?: React.ElementType;
}

MessageRibbonOverlay.displayName = "MessageRibbonOverlay";